import ListingsIcon from '@/../img/listings-icon.svg';
import OccupancyIcon from '@/../img/occupancy-icon.svg';
import RevenueIcon from '@/../img/revenue-icon.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { cssVars } from '@/app/styles';
import { datasetTypes } from '@/constants';
import * as KPI from './kpi-styles';
import { TrendDisplay } from './trend-display';

const iconByType = {
  [datasetTypes.CURRENT_STR_PROPERTIES]: ListingsIcon,
  [datasetTypes.OCCUPANCY]: OccupancyIcon,
  [datasetTypes.REVENUE]: RevenueIcon,
};

function getItemColors(thisItemType, isActive) {
  const thisItemActiveColor = cssVars.color.activeStateColor[thisItemType];
  return isActive
    ? thisItemActiveColor
    : {
        color: cssVars.color.inactiveStateColor.accentColor,
        backgroundColor: cssVars.color.inactiveStateColor.lightColor,
      };
}

function getIcon(thisItemType, isActive) {
  const Icon = iconByType[thisItemType];
  const colors = getItemColors(thisItemType, isActive);

  // using style prop, else would have to add styled wrappers for each icon individually
  return (
    <Icon
      style={{
        fill: colors.color,
        backgroundColor: colors.backgroundColor,
        borderRadius: '50%',
      }}
    />
  );
}

/**
 * Performance indicator item component
 *
 * @param {*} props
 * @param {func} Icon icon svg object
 * @param {string} label informational label for this item
 * @param {string} trend string value used for determining type of trending icon to render
 * @param {any} value main value for this performance indicator item
 *  trends can be: ["up", "down"]
 */
export function KPIItem(props) {
  const isActive = props.activeTab === props.type;
  const itemColors = getItemColors(props.type, isActive);

  return (
    <KPI.ItemWrapper onClick={props.onClick}>
      <KPI.IconWrapper>{getIcon(props.type, isActive)}</KPI.IconWrapper>
      <KPI.ItemDataWrapper>
        <TrendDisplay
          isActive={isActive}
          value={props.value}
          trend={props.trend}
        />
        <KPI.ItemLabelWrapper color={itemColors.color}>
          <span>{props.label}</span>
          {/* disabling transform. icons drawn on top of everything */}
          {/* <IconTiny style={{ transform: 'unset' }} icon={infoCircleOutline} /> */}
        </KPI.ItemLabelWrapper>
      </KPI.ItemDataWrapper>
    </KPI.ItemWrapper>
  );
}

KPIItem.propTypes = {
  label: PropTypes.string.isRequired,
  trend: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};
